
// Azure AD stores names as "First Last | Organization (tag)" — strip org suffix for Chakra Avatar initials.
export function sanitizeNameForInitials(name: string): string {
  return name.split('|')[0].trim()
}

// Citation URLs deep-link to a PDF page via a `#page=N` fragment; pull the page
// out so callers can render a label without depending on a separate field.
export function getPageNumber(href: string): number | null {
  try {
    const pageMatch = new URL(href).hash.match(/#page=(\d+)/)
    return pageMatch ? parseInt(pageMatch[1], 10) : null
  } catch {
    return null
  }
}

export function formatDate(dateString: string) {
  const date = new Date(dateString)
  const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone

  return date.toLocaleString(navigator.language || 'nl-NL', {
    timeZone: userTimeZone,
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  })
}
